// libs
import React, { memo, useEffect, useState } from 'react';
import { frontloadConnect } from 'react-frontload';

// components
import WishlistHeader from 'shared/layouts/Wishlist/Mobile/components/WishlistHeader';
import Products from './components/Products';
import API from 'shared/layouts/Wishlist/API';
import Analytics from 'shared/layouts/Wishlist/Analytics/index';
import WishlistErrorWrapper from 'shared/layouts/Wishlist/Mobile/components/ErrorWrapper';
import PriceDropStrip from 'shared/layouts/Wishlist/Mobile/components/PriceDropStrip';

// actions
import {
  setHeaderOptions as _setHeaderOptions,
  resetHeaderOptions as _resetHeaderOptions,
} from 'shared/store/app/actions';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

// context
import { useResponsiveContext } from 'shared/components/ResponsiveLoader/ResponsiveContext';

//constant
import { BREAKPOINTS } from 'shared/styles/base';

// defs
interface IWishlistMobileProps {
  setHeaderOptions: typeof _setHeaderOptions;
  resetHeaderOptions: typeof _resetHeaderOptions;
}

function WishlistMobile({ resetHeaderOptions }: IWishlistMobileProps) {
  const isPriceDropNudgeEnabled = useRemoteConfig('priceDropNudgeEnabled');
  const [showPriceDropStrip, setShowPriceDropStrip] = useState(false);
  const { deviceWidth } = useResponsiveContext();
  const isMobile = deviceWidth < BREAKPOINTS.DESKTOP;
  const showPriceDrop = isPriceDropNudgeEnabled && showPriceDropStrip && isMobile;

  useEffect(() => {
    return () => {
      resetHeaderOptions();
    };
  }, [resetHeaderOptions]);
  return (
    <>
      <API>
        <WishlistErrorWrapper>
          <Analytics isPriceDropStrip={showPriceDrop} isMobile />
          <WishlistHeader />
          {showPriceDrop && <PriceDropStrip />}
          <Products setShowPriceDropStrip={setShowPriceDropStrip} />
        </WishlistErrorWrapper>
      </API>
    </>
  );
}

const fetchData = async ({ setHeaderOptions }: IWishlistMobileProps) => {
  setHeaderOptions({
    showDiscount: false,
    showHamburger: false,
    showLogo: false,
    headerMerge: false,
    showBack: true,
    showSearch: false,
    showBottomBorder: false,
    showWishlist: false,
  });
};
export default frontloadConnect(fetchData)(memo(WishlistMobile));
